<template>
    <div id="financial-circumstances" class="financial-circumstances-wrapper pt-8 scroll-mt-56">
        <HeadingBarComponent :step="5" />
        <div class="md:flex">
            <!-- Left Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Financial Information</h3>
                <InputComponent label="Property Ownership" :value="submission.financial_circumstances.property_ownership" />
                <InputComponent label="What is your gross annual income from all sources?" :value="submission.financial_circumstances.annual_income" />
                <InputComponent label="What are your net assets?" :value="submission.financial_circumstances.net_assets" />
                <InputComponent label="Initial Deposit" :value="submission.financial_circumstances.initial_deposit" />
                <InputComponent label="Total Risk Capital" :value="submission.financial_circumstances.total_risk_capital" />
                <HrComponent />
            </div>

            <!-- Right Side -->
            <div class="basis-1/2 px-8">
                <h3 class="mb-4">Professional Classification Test</h3>
                <InputComponent label="Is your financial investment portfolio greater than 500,000 GBP?" :value="submission.financial_circumstances.financial_investment_portfolio ? 'Yes' : 'No'" />
                <InputComponent label="You work or have worked in the financial sector for at least one year in a professional position, which requires knowledge of the transactions or services envisaged;" :value="submission.financial_circumstances.worked_in_financial_sector ? 'Yes' : 'No'" />
                <InputComponent label="You have carried out transactions, in significant size, on the relevant market at an average frequency of 10 per quarter over the previous four quarters;" :value="submission.financial_circumstances.transactions_average_frequency ? 'Yes' : 'No'" />
                <InputComponent label="As you have indicated above that you could be classified as a professional customer, please confirm whether you would like to opt up to professional status?" :value="submission.financial_circumstances.opt_in_as_professional_customer ? 'Yes' : 'No'" />
                <HrComponent />
            </div>
        </div>
        <div class="px-8">
            <h3 class="mb-4">Acceptance Criteria</h3>
            <CheckboxComponent label="Please confirm that, given the risk of loss of capital in trading futures and options (derivatives) and equities, any risk capital traded through us should only represent a small percentage of your overall net worth." :value="!!submission.financial_circumstances.confirm_small_percentage_of_net_worth" />
            <HrComponent class="mt-4" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeadingBarComponent from "@adminComponents/misc/HeadingBarComponent";
import HrComponent from '@adminComponents/misc/HrComponent';
import InputComponent from '@adminComponents/inputs/InputComponent';
import CheckboxComponent from '@adminComponents/inputs/CheckboxComponent';

export default {
    name: "FinancialCircumstancesComponent",
    components: {
        HeadingBarComponent,
        HrComponent,
        InputComponent,
        CheckboxComponent
    },
    computed: {
        ...mapGetters(["submission"])
    },
    data: function () {
        return {
            isLoading: false,
            quickView: true
        };
    },
    methods: {
        // ...mapActions(["doLogout"]),
    },
};
</script>
